import { render, staticRenderFns } from "./Sports.vue?vue&type=template&id=2a01c715&scoped=true"
import script from "./Sports.vue?vue&type=script&setup=true&lang=js"
export * from "./Sports.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Sports.vue?vue&type=style&index=0&id=2a01c715&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a01c715",
  null
  
)

export default component.exports